module.exports = __webpack_public_path__ + "img/empresarios-de-la-industria-de-modas.270c2d1b.jpg";